import { api } from './base';

import { MutationArg } from 'v2/types';
import { SWRKeyValue } from 'v2/types/swr';
import { TelegramAuthBotModel, TelegramAuthBotRequestBody } from 'v2/types/TelegramAuthBotModel';

export const telegramAuthBotService = {
  getBots(): Promise<TelegramAuthBotModel[]> {
    return api.get('v1/admin/telegram-auth-bot').json();
  },

  createBot(_key: string, { arg }: MutationArg<TelegramAuthBotRequestBody>): Promise<TelegramAuthBotModel> {
    return api.post('v1/admin/telegram-auth-bot', { json: arg }).json();
  },

  updateBot([_key, id]: SWRKeyValue, { arg }: MutationArg<TelegramAuthBotRequestBody>): Promise<TelegramAuthBotModel> {
    return api.put(`v1/admin/telegram-auth-bot/${id}`, { json: arg }).json();
  },

  deleteBot([_key, id]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/telegram-auth-bot/${id}`).json();
  },
};
